// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bill-container {
    background-color: #fff;
    border: 4px solid #1f53cd;
    padding: 20px;
    width: 800px; /* Adjust width as needed */
    font-family: sans-serif;
    margin-top: 10px;
  }
  
  .bill-header {
    display: grid;
    justify-content: center;
    margin-bottom: 20px;
    text-align: center;
  }
  
  .municipal-council,
  .form,
  .bill-title,
  .financial-year {
    font-size: 18px;
    font-weight: bold;
  }
  
  .bill-body {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  
  .estate-details,
  .bill-details,
  .assessment-details,
  .owner-details,
  .tax-details,
  .notes {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
    color: #1f53cd;
  }
  
  .tax-details-title,
  .assessment-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  .tax-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .tax-table th,
  .tax-table td {
    padding: 5px;
    border: 1px solid #ddd;
    text-align: left;
  }
  
  .notes {
    font-size: 12px;
  }
  
  .note {
    margin-bottom: 5px;
  }
  
  .innerheader{
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-weight: bolder;
  }





`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/Technical Sanction/TechnicalSanctionInwards/bill.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,YAAY,EAAE,2BAA2B;IACzC,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;;;IAIE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;EAChC;;EAEA;;;;;;IAME,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,cAAc;EAChB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;EACrB","sourcesContent":[".bill-container {\n    background-color: #fff;\n    border: 4px solid #1f53cd;\n    padding: 20px;\n    width: 800px; /* Adjust width as needed */\n    font-family: sans-serif;\n    margin-top: 10px;\n  }\n  \n  .bill-header {\n    display: grid;\n    justify-content: center;\n    margin-bottom: 20px;\n    text-align: center;\n  }\n  \n  .municipal-council,\n  .form,\n  .bill-title,\n  .financial-year {\n    font-size: 18px;\n    font-weight: bold;\n  }\n  \n  .bill-body {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }\n  \n  .estate-details,\n  .bill-details,\n  .assessment-details,\n  .owner-details,\n  .tax-details,\n  .notes {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: 20px;\n    color: #1f53cd;\n  }\n  \n  .tax-details-title,\n  .assessment-title {\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 10px;\n  }\n  \n  .tax-table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .tax-table th,\n  .tax-table td {\n    padding: 5px;\n    border: 1px solid #ddd;\n    text-align: left;\n  }\n  \n  .notes {\n    font-size: 12px;\n  }\n  \n  .note {\n    margin-bottom: 5px;\n  }\n  \n  .innerheader{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    font-weight: bolder;\n  }\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
